/**
 * MarketingLayout — Marketing navbar + content only.
 * NO DashboardLayoutContext, NO drawers, NO panels.
 * Used for: /, /discover (guest), /auth, handle pages (guest).
 */
import React from 'react';
import { AppMain } from '@bright-web-skeleton/ui';
import { MarketingNavbar } from './MarketingNavbar';

interface MarketingLayoutProps {
  children: React.ReactNode;
  canonicalEntitySpace?: boolean;
}

export const MarketingLayout: React.FC<MarketingLayoutProps> = ({
  children,
  canonicalEntitySpace = false,
}) => {
  if (canonicalEntitySpace) {
    return (
      <div className="h-[100dvh] overflow-hidden bg-background text-foreground flex flex-col">
        <MarketingNavbar />
        <AppMain>{children}</AppMain>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <MarketingNavbar />
      <main className="flex-1 overflow-x-hidden">
        <div className="p-4 md:p-6">{children}</div>
      </main>
    </div>
  );
};
